
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/resources/vibe-coding",
      function () {
        return require("private-next-pages/docs/resources/vibe-coding.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/resources/vibe-coding"])
      });
    }
  